/* eslint-disable no-underscore-dangle */
import { HubPayload } from '@aws-amplify/core';
import { LogType, Logger } from '@hitiq/logger';
import { BehaviorSubject, Subject } from 'rxjs';

export class DataStoreSync {
  onNetworkStatusChanged = new Subject<boolean>();
  onDataStoreError = new Subject<any>();
  onIsSyncedChanged = new BehaviorSubject<boolean>(false);
  outboxIsEmpty = new BehaviorSubject<boolean>(true);
  onIsSyncingChanged = new Subject<boolean>();

  publishSyncEvent({ event, data }: HubPayload, logger: Logger) {
    // console.log('publishSyncEvent: ', event, data);

    if (event === 'networkStatus') {
      this.isNetworkConnected = data.active;
      this.isSynced = false;
      this.isSyncing = false;
    } else if (event === 'syncQueriesStarted') {
      this.isSyncing = true;
      this.isSynced = false;
    } else if (event === 'syncQueriesReady') {
      this.isSyncing = false;
      this.isSynced = true;
    } else if (event === 'outboxStatus') {
      this.outboxIsEmpty.next(data.isEmpty);
    } else if (event === 'ready') {
      // do something here once the data is synced from the cloud
      logger.log(LogType.debug, `Datastore: data is synced from the cloud`);
    } else if (event === 'modelSynced') {
      // do something here once the data is synced from the cloud
      logger.log(
        LogType.debug,
        `Datastore: modelSynced event for ${
          data?.model?.name
        }: ${JSON.stringify(data)}`,
      );
    }
  }

  private _isNetworkConnected: boolean = false;
  get isNetworkConnected(): boolean {
    // Reasoning: using only for getter/setter properties for ease of use.
    // eslint-disable-next-line no-underscore-dangle
    return this._isNetworkConnected;
  }
  private set isNetworkConnected(value: boolean) {
    if (this.isNetworkConnected !== value) {
      // Reasoning: using only for getter/setter properties for ease of use.
      // eslint-disable-next-line no-underscore-dangle
      this._isNetworkConnected = value;
      this.onNetworkStatusChanged.next(this.isNetworkConnected);
    }
  }

  private _dataStoreErrors: string[] = [];
  set dataStoreError(value: string) {
    this._dataStoreErrors.push(value);
    this.onDataStoreError.next(value);
  }
  get dataStoreError() {
    if (this._dataStoreErrors.length)
      return this._dataStoreErrors[this._dataStoreErrors.length - 1];
    return '';
  }
  private get dataStoreErrors() {
    return this._dataStoreErrors;
  }
  private set dataStoreErrors(value: any) {
    if (!value && Array.isArray(value) && value.length === 0)
      this._dataStoreErrors = [];
    else
      console.error(
        "Can't set dataStoreErrors except to clear it. Set most recent data store error with singular .dataStoreError = ...",
      );
  }

  private _isSyncing: boolean = false;
  get isSyncing(): boolean {
    // Reasoning: using only for getter/setter properties for ease of use.
    // eslint-disable-next-line no-underscore-dangle
    return this._isSyncing;
  }
  private set isSyncing(value: boolean) {
    if (this.isSyncing !== value) {
      // Reasoning: using only for getter/setter properties for ease of use.
      // eslint-disable-next-line no-underscore-dangle
      this._isSyncing = value;
      this.onIsSyncingChanged.next(this.isSyncing);
    }
  }

  private _isSynced: boolean = false;
  get isSynced(): boolean {
    // Reasoning: using only for getter/setter properties for ease of use.
    // eslint-disable-next-line no-underscore-dangle
    return this._isSynced;
  }
  private set isSynced(value: boolean) {
    if (this.isSynced !== value) {
      // Reasoning: using only for getter/setter properties for ease of use.
      // eslint-disable-next-line no-underscore-dangle
      this._isSynced = value;
      this.onIsSyncedChanged.next(this.isSynced);
    }
  }
}
